import { jsx as n } from "react/jsx-runtime";
function e(t) {
  const h = t.width || "16", i = t.height || "16";
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: h,
      height: i,
      viewBox: "0 0 16 16",
      fill: "none",
      ...t,
      children: /* @__PURE__ */ n(
        "path",
        {
          d: "M5.33083 11.5013L2.41156 8.58207C2.08626 8.25678 1.56914 8.25678 1.24385 8.58207C0.918555 8.90736 0.918555 9.42449 1.24385 9.74978L4.73863 13.2446C5.06392 13.5699 5.58939 13.5699 5.91468 13.2446L14.7559 4.41168C15.0812 4.08639 15.0812 3.56926 14.7559 3.24397C14.4306 2.91868 13.9135 2.91868 13.5882 3.24397L5.33083 11.5013Z",
          fill: "currentColor"
        }
      )
    }
  );
}
export {
  e as C
};
